import React from 'react';
import { Grid, Typography } from '@mui/material';

export const Summary = ({ values }) => {
	return (
		<Grid container spacing={2} className='mt-3'>
			{values.map(({ title, value }, i) => {
				return (
					<Grid item xs={3} key={`field-${i}`}>
						<Typography variant='p'>{title}</Typography>
						<Typography variant='h6'>{value}</Typography>
					</Grid>
				);
			})}
		</Grid>
	);
};
